var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81055 11.8984C12.572 11.8984 14.8105 9.65986 14.8105 6.89844C14.8105 4.13701 12.572 1.89844 9.81055 1.89844C7.04912 1.89844 4.81055 4.13701 4.81055 6.89844C4.81055 9.65986 7.04912 11.8984 9.81055 11.8984Z",
    stroke: "#333333",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8106 13.8984H15.1626C15.8937 13.8986 16.5995 14.1658 17.1475 14.6497C17.6955 15.1336 18.048 15.801 18.1386 16.5264L18.5296 19.6504C18.5648 19.9319 18.5397 20.2176 18.456 20.4885C18.3723 20.7595 18.232 21.0096 18.0442 21.2222C17.8565 21.4348 17.6257 21.6051 17.3672 21.7217C17.1086 21.8382 16.8282 21.8985 16.5446 21.8984H3.07661C2.79299 21.8985 2.5126 21.8382 2.25405 21.7217C1.9955 21.6051 1.76471 21.4348 1.57698 21.2222C1.38926 21.0096 1.24889 20.7595 1.16521 20.4885C1.08153 20.2176 1.05644 19.9319 1.09161 19.6504L1.48161 16.5264C1.5723 15.8007 1.92502 15.133 2.47344 14.6491C3.02186 14.1651 3.72819 13.8982 4.45961 13.8984H4.81061",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.01eaa7f8830bdfb11a7c8c8ff5426c9c.svg";
export { ForwardRef as ReactComponent };